import React from 'react'

import useInterfaceLocale from '../../modules/locale/useInterfaceLocale'

import style from './style.module.scss'
import useTheme from '@aytm/app/swidget/base/modules/theme/useTheme'
import { SurveyMode } from '@aytm/app/swidget/base/actions/types'

export interface INavigationPanelPrivacyProps {
  mode: SurveyMode
}

const NavigationPanelPrivacy = React.memo<INavigationPanelPrivacyProps>(
  ({ mode }) => {
    const theme = useTheme()
    const { t } = useInterfaceLocale()

    return (
      <>
        {theme.style.privacyURL && mode != SurveyMode.XRAYS ? (
          <a
            className={style.NavigationPanelHref}
            href={theme.style.privacyURL}
            style={{ color: theme.style.accentColor }}
            target="_blank"
            rel="noreferrer"
            data-testid="SW-PrivacyLink"
          >
            {t('preview', 'texts', 'privacy')}
          </a>
        ) : null}
      </>
    )
  },
  (_prevProps, _nextProps) => true
)

NavigationPanelPrivacy.displayName = 'NavigationPanelPrivacy'

export default NavigationPanelPrivacy
